/**
 * [Phase 2c.6-A.2.1 D-6 / RL-34] AdamAvatarBadge - unified Adam-voice label.
 *
 * Consumed by:
 *   - LiveActivityFeed header (draft-side)             label="ADAM · LIVE"
 *   - LeagueHome SEASON_WELCOME banner (season-side)   label="ADAM · SEASON WELCOME"
 *   - DraftEndRecapModal header                        label="ADAM · END OF DRAFT"
 *   - (A.2.2) PlayerAnalysisModal header               label="ADAM · ANALYSIS"
 *
 * Visual contract: PGF-orange vertical glow bar + uppercase tracking-wide
 * label. Optional `size` ("xs" | "sm" | "md") for header-size variants.
 * No animation by default; callers can opt-in via `pulse={true}` for the
 * live-on-clock variant in StandaloneDraftBoard.
 */
const SIZES = {
  xs: { bar: "w-1 min-h-[18px]", label: "text-[9px] tracking-[0.32em]" },
  sm: { bar: "w-1.5 min-h-[22px]", label: "text-[10px] tracking-[0.30em]" },
  md: { bar: "w-2 min-h-[28px]", label: "text-xs tracking-[0.22em]" },
};

export default function AdamAvatarBadge({
  label = "ADAM · LIVE",
  size = "sm",
  pulse = false,
  testid = "adam-avatar-badge",
}) {
  const s = SIZES[size] || SIZES.sm;
  return (
    <div
      className="flex items-center gap-2.5"
      data-testid={testid}
    >
      <div
        className={`${s.bar} rounded-full`}
        style={{
          background: "#FF6B00",
          boxShadow: pulse
            ? "0 0 10px rgba(255,107,0,0.85), 0 0 22px rgba(255,107,0,0.45)"
            : "0 0 8px rgba(255,107,0,0.55)",
          animation: pulse ? "pgf-pulse 1.6s ease-in-out infinite" : undefined,
        }}
      />
      <span
        className={`${s.label} font-display font-bold uppercase text-[#FF6B00]`}
        style={{ letterSpacing: undefined }}
      >
        {label}
      </span>
    </div>
  );
}
